import { render, staticRenderFns } from "./ExpenseConfigLinkedRevenueContainer.vue?vue&type=template&id=0057de5e&scoped=true&"
import script from "./ExpenseConfigLinkedRevenueContainer.vue?vue&type=script&lang=js&"
export * from "./ExpenseConfigLinkedRevenueContainer.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseConfigLinkedRevenueContainer.vue?vue&type=style&index=0&id=0057de5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057de5e",
  null
  
)

export default component.exports